import { pendoTags } from '../../../../../../../../../../../../shared/constants';
import { PROVIDER_REVIEW_STEP } from '../../../../../writeback.types';

export function getPendoTagForProviderReviewStep(step: PROVIDER_REVIEW_STEP): string {
  switch (step) {
    case PROVIDER_REVIEW_STEP.APPROVAL_DISCLAIMER:
      return pendoTags.providerReviewV2.approvalDisclaimer;

    case PROVIDER_REVIEW_STEP.APPROVAL_SIGNATURE:
      return pendoTags.providerReviewV2.approvalSignature;

    case PROVIDER_REVIEW_STEP.APPROVAL_NOTE:
      return pendoTags.providerReviewV2.approvalNote;

    case PROVIDER_REVIEW_STEP.REJECTION_NOTE:
      return pendoTags.providerReviewV2.rejectionNote;

    case PROVIDER_REVIEW_STEP.SYNC:
      return pendoTags.providerReviewV2.sync;

    default:
      return '';
  }
}

interface ShouldDisablePrimaryButtonPayload {
  currentProviderReviewStep: PROVIDER_REVIEW_STEP;
  providerReviewNote: string;
}

export function shouldDisablePrimaryButton({
  currentProviderReviewStep,
  providerReviewNote,
}: ShouldDisablePrimaryButtonPayload): boolean {
  switch (currentProviderReviewStep) {
    case PROVIDER_REVIEW_STEP.APPROVAL_NOTE:
    case PROVIDER_REVIEW_STEP.REJECTION_NOTE:
      return providerReviewNote.length === 0;

    default:
      return false;
  }
}
